import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-phone-icon",
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.657 18">
      <path
        id="Caminho_127"
        data-name="Caminho 127"
        d="M144.8,136.516a4.717,4.717,0,0,1-3.239,2.086c-.858.048-.882.666-5.561-1.368s-7.5-6.977-7.719-7.3a8.979,8.979,0,0,1-1.727-4.866,5.194,5.194,0,0,1,1.783-3.805,1.806,1.806,0,0,1,1.268-.535c.367,0,.606-.008.878,0s.682-.056,1.037.886,1.2,3.259,1.312,3.494a.85.85,0,0,1,.008.814,3.232,3.232,0,0,1-.5.758c-.243.259-.511.586-.73.786-.243.223-.5.463-.243.937a13.969,13.969,0,0,0,2.481,3.307,12.674,12.674,0,0,0,3.67,2.441c.459.251.734.223,1.017-.076s1.217-1.312,1.548-1.763.638-.363,1.061-.2,2.677,1.38,3.135,1.627.766.379.874.574a3.817,3.817,0,0,1-.355,2.194Z"
        transform="translate(-126.547 -120.727)"
        [attr.fill]="fill"
      />
    </svg>
  `,
  styles: [
    `
      svg {
        display: block;
      }
    `,
  ],
})
export class PhoneIconComponent implements OnInit {

  @Input()
  fill = "#f27c00"; // Default fill color

  constructor() {}

  ngOnInit() {}
}
